import React from 'react';
import PermissionOption from './PermissionOption';

const PermissionManager = ({ permissions = [], currentValues = [], onChange }) => {
  const handleModuleChange = (moduleName, newValues) => {
    if (!Array.isArray(newValues)) return;
    
    // Actualizar los permisos del módulo
    const updatedValues = currentValues.map(module => {
      const matchingModule = newValues.find(m => m.module_id === module.module_id);
      if (matchingModule) {
        return matchingModule;
      }
      return module;
    });

    console.log('PermissionManager change:', { moduleName, newValues, updatedValues });
    onChange(updatedValues);
  };

  return (
    <div className="permission-section">
      {permissions.map((module) => (
        <PermissionOption
          key={module.id}
          title={module.name}
          children={module.children || []}
          currentValues={currentValues}
          onChange={(newValues) => handleModuleChange(module.name, newValues)}
        />
      ))}
    </div>
  );
};

export default PermissionManager;